export enum ErrorCodes {
  ApiError = 1,
  Error = 1000,
  InvalidUserSession = 1001,
  InvalidApiKey = 1002,
  InvalidParams = 1003,

  AuthFacebookAPIError = 1004,
  AuthInvalidToken = 1005,
  UserAlreadyLogged = 1006,
  AuthAccountNotFound = 1007,
  AuthFacebookExpireSession = 1008,
  ApiVersionNotFound = 1009,

  DisplayNameInvalidError = 1013,
  UserDisplayNameAlreadyUsedError = 1014,
  InvalidUserDeviceError = 1015,
  FreeCreditsNotAvailable = 1016,
  UserDeleteInProgress = 1017,
  UserDeleted = 1018,
  UserBanned = 1019,

  UserWorldNotFoundError = 2000,
  UserWorldElementUpgradeTooExpensiveError = 2001,

  SlotTooExpensiveError = 3000,

  MatchNotFound = 4000,
  MatchLaunchTooExpensive = 4001,
  MatchTournamentInvalid = 4002,
  MatchUserNotFound = 4003,

  ChestNotFound = 5000,
  ChestUnopenable = 5001,

  IapInvalidReceiptError = 6000,
  IapReceiptValidationError = 6001,

  MissionInvalidError = 7000,
  MissionClaimError = 7001,

  TournamentLaunchTooExpensive = 8000,

  MatchmakingNotFound = 9000,
  MatchmakingTimeout = 9001,
  MatchmakingFailed = 9002,
  MatchmakingPollRateLimit = 9003,

  NewsClaimError = 10000
}
